<template>
  <div class="py-10 min-h-screen bg-white">
    <Sidebar></Sidebar>
    <Header>{{ user.name }} {{ user.surname }}</Header>
    <div class="bg-pink pb-8 pt-8 px-10 text-center block">
      <div class="container mx-auto">
        <div class="flex items-baseline">
          <div class="relative flex-1">
            <img
              class="w-24 h-24 rounded-full border-4 align-middle z-3 relative "
              src="/img/user.png"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto my-auto">
      <div class="text-right pr-4 py-5">
        <i
          class="fas fa-check text-green"
          @click="editProfile"
        ></i>
      </div>
      <div class="px-4 pb-4">
        <p class="text-blue-dark">
          <b> {{$t('all.profile_data')}} </b>
        </p>
        <div class="flex">
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_name')}}</i><br>
              <input
                class="p-2 w-9/10"
                disabled
                type="text"
                v-model="user.name"
                name="name"
              >
            </p>
          </div>
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_last_name')}}</i><br>
              <input
                class="p-2 w-9/10"
                disabled
                type="text"
                v-model="user.surname"
                name="surname"
              >
            </p>
          </div>
        </div>
        <div class="pt-4">
          <p class="pb-2">
            <i class="text-xs">{{$t('all.profile_fiscal_code')}}</i><br>
            <input
              class="p-2 w-9/10"
              disabled
              type="text"
              v-model="user.fiscal_code"
              name="fiscal_code"
            >
          </p>
        </div>
        <div class="flex">
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.profile_phone')}}</i><br>
              <input
                class="p-2 w-9/10"
                maxlength="10"
                type="text"
                v-model="user.phone"
                name="phone"
              >
            </p>
          </div>
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i class="text-xs">
                {{getRole('tutor') ? $t('all.emergency_phone') : getRole('teacher') ? $t('all.profile_mobile') : ''}}
              </i>

              <input
                class="p-2 w-9/10"
                maxlength="10"
                type="text"
                v-model="user.mobile"
                name="mobile"
              >
            </p>
          </div>
        </div>
        <div class="flex pt-4">
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i>{{ $t('all.showReferences')}}</i>
            </p>
          </div>
          <div class="pt-4 flex-1 text-right">
            <div class="form-switch inline-block align-middle text-right">
              <input
                type="checkbox"
                v-model="user.show_contacts"
                name="1"
                id="1"
                class="form-switch-checkbox"
              />
              <label
                class="form-switch-label"
                for="1"
              ></label>
            </div>
          </div>
        </div>
        <div class="flex pt-4">
          <div class="flex-1 pt-2">
            <p class="pb-2"><i>{{$t('all.choose_language')}}</i></p><br>
          </div>
          <div class="flex-1">
            <div class="my-auto">
              <select
                v-model="selectedLanguage"
                class="w-full border bg-white py-2 px-3 focus:outline-none"
                id="grid-state"
              >
                <option
                  v-for="lang in languages"
                  :value="lang.lang"
                  :key="lang.lang"
                >{{lang.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';
import find from 'lodash/find';

export default {
  props: ['id'],
  async created() {
    await this.getUserInfo();
    this.selectedLanguage = this.$i18n.locale;
  },
  data() {
    return {
      showContact: false,
      selectedLanguage: '',
      languages: [
        { name: 'English', lang: 'en' },
        { name: 'Italiano', lang: 'it' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: 'authentication/individual',
    }),
  },
  methods: {
    ...mapActions('authentication', ['updateUserInfo', 'getUserInfo']),
    async editProfile() {
      const { user } = this;
      delete user.created_at;
      delete user.updated_at;
      user.language = this.selectedLanguage;
      await this.updateUserInfo({ user });
      this.$router.replace({ name: 'Profilo' });
    },
    getRole(role) {
      return authService.hasRole(role);
    },
    toggle() {
      this.showContact = !this.showContact;
    },
  },
};
</script>
